import React, {useEffect, useState, useContext} from 'react';
import {Popover, Button, message} from 'antd';
import {AxiosRequestWithImba} from "../../helpers/AxiosRequest";
import {RoleContext} from "../../contexts/RoleContext";


const Break = ({record, imba_id}) => {
    const [visible, setVisible] = useState(false);

    const success = (text) => {
        message.success(text);
    };

    const onBreak = (item) => {
        AxiosRequestWithImba('room_disconnect', {
            room_id: record.room_id,
        }, imba_id).then((data) => {
            if (!data.error)
            {
                success('Successfully Break!')
                setVisible(false)
            }
        })
    }

    const handleVisibleChange = (visible) => {
        setVisible(visible)
    };

    const content = (
        <div>
            <Button className={'m-1'} onClick={() => onBreak(record)}>OK</Button>
        </div>
    );
    const {getRole} = useContext(RoleContext);
    let role = getRole()

    if(role !='operator'){
    return (
        <Popover visible={visible} placement="topLeft" title={'Confirm break'} content={content} trigger={'click'} onVisibleChange={handleVisibleChange}>
            <a className={'button'} style={{ margin: '0 0px' }}  room_id={`${record.room_id}`}>Break</a>
        </Popover>
    );
    }
    else{
        return (
            <>
            </>
        );
    }
};


export default Break;